



























import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

const $ = require('jquery');

import UrlMix from '@/mixins/url';
import Formatter from '@/mixins/formatter';

@Component
export default class StickySideBar extends mixins(UrlMix, Formatter) {
  @Prop() initialTotalAmount!: number;
  @Prop() totalAmountOfMonth!: number;

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const nav = $('.estimate');
    nav.offset();
    if ($(window).scrollTop() > 0) {
      nav.addClass('fixed');
    } else {
      nav.removeClass('fixed');
    }
  }
}
